import { ConciergeKnowledgeSchema } from "@redotech/redo-concierge-common/concierge-knowledge";
import * as z from "zod";

export const getSuggestedKnowledge = {
  name: "getSuggestedKnowledge" as const,
  input: z.object({ filters: z.object({ searchText: z.string().optional() }) }),
  output: z.array(ConciergeKnowledgeSchema),
};

export type GetSuggestedKnowledgeOutput = z.infer<
  typeof getSuggestedKnowledge.output
>;
